import styled from "styled-components";
const StyledTRUCert = styled.section`
  //png certificate

  &.capture .cert-bg {
    display: none;
  }

  &.capture .tassles {
    display: none;
  }

  &.capture .dlIcon {
    display: none;
  }

  &.capture {
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: white;
  }

  &.capture .canvas-box {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
  }

  &.capture .canvas-header {
    position: absolute;
    top: 11.10%;
    left: 21%;
  }
  &.capture .canvas-header .canvas-header-text {
    margin: unset;
    line-height: 150%;
    font-size: 16px;
    position: relative;
    color: white;
    font-weight: 300;
  }
  &.capture .canvas-header .canvas-header-text:nth-of-type(2) {
    margin-left: 1rem;
  }
  &.capture .canvas-body {
    position: absolute;
    top: 33.5%;
    left: 33%;
  }
  &.capture .canvas-body .canvas-body-text {
    font-size: 16px;
    line-height: 147%;
  }
  &.capture .canvas-body .canvas-body-text:nth-of-type(8) {
    margin-top:3.9rem;
    position: relative;
    line-height: 145%;
    width: 110%;
  }
  &.capture .canvas-body .canvas-body-text:nth-of-type(9) {
  }
  &.capture .canvas-body .canvas-body-text strong {
    margin: 0 1rem;
    font-weight: 600;
    font-size: 16px;
  }
  &.capture .canvas-congrats-text {
    position: absolute;
    font-size: 40px;
    width: 79%;
    text-align: justify;
    background: white;
    color: var(--darkblue);
    top: 34.5%;
    left: 9.5%;
  }
  &.capture .canvas-works-text {
    position: absolute;
    top: 60.35%;
    left: 35.5%;
    color: var(--darkblue);
    font-size: 16px;
  }
  &.capture .canvas-contact-card {
    position: absolute;
    bottom: 12%;
    right: 10%;
    display: block;
    width: fit-content;
  }

  &.capture .canvas-contact-text {
    width: 100%;
    white-space: nowrap;
    text-align: right;
    font-size: 16px;
    line-height:130%;
    color: var(--darkblue);
  }
  &.capture .canvas-contact-text:nth-of-type(1) {
    font-weight: 800;
  }
  &.capture .qr-box {
    position: absolute;
    bottom: 12%;
    left: 9.5%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  &.capture .qr-code {
    width: 100%;
    height: auto;
    max-width: 8rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px;
    border: 3px solid black;
    background: white;
  }
  &.capture .qr-code svg {
    max-width: 100%;
    width: 100%;
    z-index: 1;
    height: auto;
    position: relative;
  }
  &.capture .qr-text {
    font-size: 16px;
    color: var(--lightblue);
    margin-left: 1rem;
    width: 12rem;
  }
`;
export default StyledTRUCert;
